import api from "./api";

export const getFaq = async (params) => {
  return api.get("faq", params, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
